import { Mixin } from "@/mixin";

const set = (key) => (state, val) => {
  state[key] = val;
};

function initialState() {
  return {
    lines: [],
    total: 0,
    query: {},
    loading: false,
  };
}

const getStatus = (item) => {
  let text = "";
  if (item.state === "pending") {
    text = "منتظر فعالسازی";
  } else if (item.state === "deactivate") {
    text = "غیر فعال";
  }
  return text;
};

const getColor = (item) => {
  let color = "#000000";

  if (item.user_id === null) {
    color = "#1565c0";
  }
  // if (
  //   item.user_id === null &&
  //   (item.subnumber?.phone === "5004" || item.subnumber?.phone === "5002")
  // ) {
  //   color = "#2e7d32";
  // }

  // if (item.user_id !== 88 && item.user_id !== null) {
  //   color = "#6a1b9a";
  // }
  // if (item.subnumber?.phone === "12345") {
  //   color = "#c62828";
  // }

  // if (item.category?.title === "سفارشی" && item.user_id !== 88) {
  //   color = "#ef6c00";
  // }

  // if (item.user_id === 88) {
  //   color = "#424242";
  // }

  return color;
};

const getters = {
  voiceLines: (state) => state.lines,
  voiceTotal: (state) => state.total,
  voiceLoading: (state) => state.loading,
};

const actions = {
  fetchVoiceOperators({ commit }) {
    commit("setLoading", true);

    Mixin.methods
      .requestApiGetPayamak("phone?type=call")
      .then((response) => {
        console.log("api phone?type=call", response.data.data);
        const reformat = response.data.data.map((item) => {
          const isNews = false;

          let label = "";

          const mainNumber = item.subnumber?.phone || "";
          const extraNumbers = item.numbers || "";
          label += mainNumber + extraNumbers + " ";

          const userName = item.user
            ? ` ${item.user.name?.trim() || ""} ${
                item.user.lastName?.trim() || ""
              } `
            : "";
          label += userName;

          const coloredText = `<span style="color: ${getColor(
            item,
          )}">${label.trim()}</span>`;

          return {
            value: mainNumber + extraNumbers,
            text: coloredText,
            category_id: item.category_id,
            raw: item,
          };
        });

        commit("setLines", reformat);
        commit("setTotal", response.data.total || reformat.length);
      })
      .catch((err) => {
        console.error("خطا در بارگذاری اپراتورهای صوتی:", err);
      })
      .finally(() => commit("setLoading", false));
  },
};

const mutations = {
  setLines: set("lines"),
  setTotal: set("total"),
  setLoading: set("loading"),
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
